import { onError } from 'apollo-link-error';
import { createErrorHandler } from '@/utils/graphql-errors';
import i18n from '@/i18n';
import sMessage from '@/components/UI/Message/Message';
import router from '@/router/index';

const notifier = {
  error: (msg: string) => {
    sMessage.error(msg);
  },
  log: (msg: string) => {
    // eslint-disable-next-line no-console
    console.error(msg);
  },
};

const errorService = createErrorHandler({
  notifier: notifier,
  router: {
    push: (route) => router.push(route),
  },
  translator: i18n,
});

export default onError((errors) => {
  // An operation whose failure the caller handles itself, without the user
  // having to know (the postal code autofill), asks for no message.
  if (errors.operation.getContext().quietErrors) return;

  errorService.handle(errors);
});
